var map = {
	"./hg.png": 6211,
	"./hs.png": 8117,
	"./lf.png": 2925,
	"./ls.png": 8791,
	"./seaweed.png": 6261,
	"./seaweed1.png": 8416,
	"./ts.png": 2261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5227;